import { render, staticRenderFns } from "./refundPolicy.vue?vue&type=template&id=4fdd2eaa&scoped=true"
import script from "./refundPolicy.vue?vue&type=script&lang=js"
export * from "./refundPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd2eaa",
  null
  
)

export default component.exports